import * as constants from './constants';
import {
  fromJS
} from 'immutable';
const defaultState =  fromJS({
    liveinfo: [],
    memberlist:{},
    chatList:[],
   
})
function handleCartAdd(state, action) {
    return state.merge({
       memberlist: state.get('memberlist').concat(action.memberlist)
        
   });
}

 
function removeItem(state, action) {
  return (state.update('memberlist', list => {list.filter(item => console.log(item.get('id')!==action.memberlist))}))
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.CHANGE_LIVE_INFO:
            return state.merge({
               liveinfo:action.liveinfo
            });
        case constants.GET_MEMBERLIST:
            return state.merge({
                memberlist:action.memberlist
            })
        case constants.ADD_MEMBERLIST:
            return state.merge({
              memberlist:  state.get('memberlist').concat(action.memberlist)
          });
        case constants.REMOVE_MEMBERLIST:
            return removeItem(state, action); 
        case constants.CHANGE_CHAT_LISTS:
           return state.merge({
              chatList:action.chatList
           })
        default:
            return state;
    }
}
 